import { IProductType, ProductType } from './../models/productType.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ProductTypeService {

  constructor(private http: HttpClient) { }

  getProductType(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/product_type/all-cat`, { 'headers': headers });
  }

  query(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/product_type` + (size ? '?page=' + page + '&size=' + size : ''));
  }

  getCharacteristicsBySubProductId(productTypeId: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/characteristic/productType/${productTypeId}`);
  }

  getproductTypeBycurrentSearch(search: string, page: number, size: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/product_type` + ('/_search?search=name:' + search + '&page=' + page + '&size=' + size), { 'headers': headers });
  }

  saveProductType(ProductType: IProductType) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/product_type`, ProductType, { 'headers': headers });
  }

  getIdProductType(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/product_type/` + idA, { 'headers': headers });
  }

  getProductTypeVariants(subCategoryId: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get(`${environment.url}/product_type/variant/` + subCategoryId, { 'headers': headers });
  }

  updateProductType(ProductType: IProductType) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/product_type/` + ProductType.id, ProductType, { 'headers': headers });
  }

  deleteProductType(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/product_type/` + idA, { 'headers': headers });
  }

  deleteCharacteristicByProductType(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/product_type/characteristic/` + idA, { 'headers': headers });
  }

  updateVariant(id: string, idProductType: number): Observable<any> {
    const headers = new HttpHeaders().set('kapo_session_id', localStorage.getItem('kapo_session_id') || '');
    return this.http.put<any>(`${environment.url}/product_type/update/variant/${id}?idProductType=${idProductType}`, {}, { headers });
  }

  updateSubCategoryProduct(productTypeList: ProductType[], idCategorieB: number): Observable<any> {
    const headers = new HttpHeaders().set('kapo_session_id', localStorage.getItem('kapo_session_id') || '');
    return this.http.put<any>(`${environment.url}/product_type/move/product?idProductType=${idCategorieB}`,
      productTypeList, { headers });
  }
}
